import './assets/main.css'
import './assets/styles.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import vue3ToPdf from 'vue3-to-pdf'
import VueFriendlyIframe from 'vue-friendly-iframe';

import App from './App.vue'
import router from './router'

import "./assets/index.css";
import "primeflex/primeflex.css";
import 'primeicons/primeicons.css';
import "primevue/resources/themes/lara-light-purple/theme.css";

import PrimeVue from "primevue/config";
import AnimateOnScroll from 'primevue/animateonscroll';
import BadgeDirective from "primevue/badgedirective";
import FocusTrap from 'primevue/focustrap';
import Ripple from 'primevue/ripple';
import StyleClass from 'primevue/styleclass';
import Tooltip from 'primevue/tooltip';
import Toast from 'primevue/toast';
import ToastService from 'primevue/toastservice';

import Card from 'primevue/card';
import InputText from 'primevue/inputtext';
import Button from 'primevue/button';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Divider from 'primevue/divider';
import Chip from 'primevue/chip';
import Avatar from 'primevue/avatar';
import Panel from 'primevue/panel';
import ConfirmDialog from 'primevue/confirmdialog';
import Dialog from 'primevue/dialog';
import ConfirmationService from 'primevue/confirmationservice';
import Dropdown from 'primevue/dropdown';
import ProgressSpinner from 'primevue/progressspinner';
import FileUpload from 'primevue/fileupload';

import Highcharts from 'highcharts'
import VueHighcharts from 'vue3-highcharts';

const app = createApp(App)

app.use(VueHighcharts, {
    highcharts: Highcharts
});

app.component('Avatar', Avatar);
app.component('Toast', Toast);
app.component('Chip', Chip);
app.component('Card', Card);
app.component('Divider', Divider);
app.component('Button', Button);
app.component('DataTable', DataTable);
app.component('Column', Column);
app.component('Panel', Panel);
app.component('InputText', InputText);
app.component('Dialog', Dialog);
app.component('Dropdown', Dropdown);
app.component('ConfirmDialog', ConfirmDialog);
app.component('ProgressSpinner', ProgressSpinner);
app.component('FileUpload', FileUpload);

app.directive('tooltip', Tooltip);
app.directive('badge', BadgeDirective);
app.directive('ripple', Ripple);
app.directive('styleclass', StyleClass);
app.directive('focustrap', FocusTrap);
app.directive('animateonscroll', AnimateOnScroll);

app.use(createPinia());
app.use(router);
app.use(vue3ToPdf);
app.use(VueFriendlyIframe);
app.use(ToastService);
app.use(ConfirmationService);
app.use(PrimeVue, { ripple: true });

app.mount('#app')
